var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/core-mto-product-tile-swatch-options.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<span class=\"u-clearfix\">\n\t<a class=\"o-list-swatches__more\" href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "productLink"), env.opts.autoescape);
output += "\" title=\"";
output += runtime.suppressValue((lineno = 1, colno = 64, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["mto-product_tile-more-options"])), env.opts.autoescape);
output += "\">\n\t\t";
output += runtime.suppressValue((lineno = 2, colno = 4, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["mto-product_tile-more-options"])), env.opts.autoescape);
output += "\n    </a>\n</span>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/core-mto-product-tile-swatch-options.j2"] , dependencies)